/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Addr_Wiz_NoneInputs */

const cs_addr_wiz_none = /** @type {(inputs: Addr_Wiz_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Žádné spárované nemovitosti s neúplnou adresou.`)
};

const en_addr_wiz_none = /** @type {(inputs: Addr_Wiz_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No matched properties with incomplete addresses.`)
};

/**
* | output |
* | --- |
* | "No matched properties with incomplete addresses." |
*
* @param {Addr_Wiz_NoneInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const addr_wiz_none = /** @type {((inputs?: Addr_Wiz_NoneInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Addr_Wiz_NoneInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_addr_wiz_none(inputs)
	return cs_addr_wiz_none(inputs)
});